import { FeatureFlag } from '../FeatureFlag';

export const enableLabAutoAcceptPercent = new FeatureFlag({
    key: 'enable-lab-auto-accept-percent',
    createdOn: '2025-12-09',
    defaultValue: false,
});
